import { Divider, Grid, Paper, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

import type { DeliveryFormType } from "../types";

type Step0StringField =
  | "step0.clientFirstName"
  | "step0.clientLastName"
  | "step0.clientPhone"
  | "step0.clientEmail"
  | "step0.clientCompany"
  | "step0.clientSiret";

const CLIENT_FIELDS: Array<[Step0StringField, string, string]> = [
  ["step0.clientFirstName", "common.form.input.first-name", "text"],
  ["step0.clientLastName", "common.form.input.last-name", "text"],
  ["step0.clientPhone", "common.form.input.phone", "tel"],
  ["step0.clientEmail", "common.form.input.email", "email"],
  ["step0.clientCompany", "client.form.company", "text"],
  ["step0.clientSiret", "client.form.siret", "text"],
];

interface Props {
  form: DeliveryFormType;
}

export function ClientSection({ form }: Props) {
  const { t } = useTranslation();

  return (
    <Paper elevation={4} sx={paperSx}>
      <Grid container direction="row" spacing={2} paddingBottom={2}>
        <Grid size={{ xs: 12 }}>
          <Typography variant="h5">{t("delivery.form.client")}</Typography>
        </Grid>
        <Grid size={{ xs: 12 }}>
          <Divider sx={dividerSx} />
        </Grid>

        {CLIENT_FIELDS.map(([name, label, type]) => (
          <Grid size={{ md: 6, xs: 12 }} key={name}>
            <form.AppField name={name}>
              {type === "tel"
                ? (field) => <field.PhoneField label={t(label)} />
                : (field) => <field.TextField label={t(label)} type={type} />}
            </form.AppField>
          </Grid>
        ))}

        <Grid size={{ xs: 12 }}>
          <form.AppField name="step0.clientDrivingLicenceNumber">
            {(field) => <field.TextField label={t("client.form.driving-licence-number")} />}
          </form.AppField>
        </Grid>
      </Grid>
    </Paper>
  );
}

const paperSx = { backgroundColor: "#E7E6F7", borderRadius: 1, padding: "20px", height: "100%" };
const dividerSx = { bgcolor: "#fe5d8d", marginBottom: 5 };
